import axios from "axios";
const actions = {
  getUserList(context) {
    context.commit("SET_USER_LIST");
    let getUrl = context.getters.backendServer + "user";
    return axios
      .get(getUrl)
      .then(function(response) {
        context.commit("SET_USER_LIST", response.data);
        return response.data;
      })
      .catch(function(e) {
        context.commit("SET_USER_LIST", e);
        context.dispatch("triggerError", e);
      });
  }
};

export default actions;
